import { useId } from 'react'
import type { ReactElement } from 'react'
import { PhonePromptCard } from './PhonePromptCard'
import { PromptBenefitList } from './PromptBenefitList'
import { PROMPT_COPY } from './promptCopy'
import styles from './phonePromptText.module.css'

/** Phone, route page, variant A (Google Maps-like) — Figma 9334:61216 / 9348:17559. */
export function PhoneRouteAPrompt({
  storeHref,
  onGetTheApp,
  onBack,
}: {
  readonly storeHref: string
  readonly onGetTheApp: () => void
  readonly onBack: () => void
}): ReactElement {
  const titleId = useId()
  return (
    <PhonePromptCard
      labelledBy={titleId}
      placement="bottom"
      icon="large"
      contentTop={70}
      primary={{ label: PROMPT_COPY.continue }}
      primaryHref={storeHref}
      secondary={{ label: PROMPT_COPY.backToWeb }}
      order="secondaryFirst"
      onPrimary={onGetTheApp}
      onSecondary={onBack}
    >
      <h2 id={titleId} className={styles.routeTitle}>
        {PROMPT_COPY.routeA.title}
      </h2>
      <PromptBenefitList benefits={PROMPT_COPY.routeA.benefits} layout="inline" />
    </PhonePromptCard>
  )
}
